import { render, staticRenderFns } from "./ChartsOrderan.vue?vue&type=template&id=0c92e916&scoped=true&"
import script from "./ChartsOrderan.vue?vue&type=script&lang=js&"
export * from "./ChartsOrderan.vue?vue&type=script&lang=js&"
import style0 from "./ChartsOrderan.vue?vue&type=style&index=0&id=0c92e916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c92e916",
  null
  
)

export default component.exports